import React, { useState } from "react";
import { Row, Col, Button, Form, Input, message } from "antd";
import { IoCallOutline } from "react-icons/io5";
import { FaGlobe, FaInstagramSquare, FaLinkedin } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { TiLocationOutline } from "react-icons/ti";
import { AiFillFacebook } from "react-icons/ai";
import { FaSquareXTwitter } from "react-icons/fa6";
import { ContactUsapi } from "../../../utils/API";

const Counter = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false); // Loading state

  const handleSubmit = async (values: any) => {
    console.log("values", values);
    setLoading(true); // Start loading
    try {
      const response = await ContactUsapi(values);
      console.log("response", response);
      if (response && response.data && response.data.message) {
        message.success(response.data.message);
        form.resetFields();
      } else {
        message.error("Email already exists, please use a different email.");
      }
    } catch (error) {
      console.log("error", error);
      message.error("Email already exists, please use a different email.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="pt-3 sm:pt-5 lg:p-5 xs:p-3 md:p-6 xxs:p-3 lg:pl-12 lg:pr-12 bg-[#FFF8EC]">
      <h1 className="text-[24px] md:text-[30px] font-normal">Get in touch with us!</h1>
      <div className="flex flex-col sm:flex-row gap-8 sm:gap-20 mt-5">
        <div className="w-full sm:w-1/2 pb-10 bg-[#FFF8EC]">
          <Form
            layout="vertical"
            form={form}
            onFinish={handleSubmit}
            requiredMark="optional"
            className="space-y-10"
          >
            <Form.Item
              name="name"
              rules={[{ required: true, message: "Please enter your name" }]}
              className="relative w-full"
            >
              <div className="relative">
                <label
                  htmlFor="name"
                  className="absolute -top-4 z-1 left-10 bg-[#FFF8EC] px-2 text-[20px] text-black"
                >
                  Your Name
                </label>
                <Input
                  id="name"
                  placeholder="Enter your name"
                  className="w-full p-3 border border-black rounded-xl bg-[#FFF8EC] focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
              className="relative w-full"
            >
              <div className="relative">
                <label
                  htmlFor="email"
                  className="absolute -top-4 z-1 left-10 bg-[#FFF8EC] px-2 text-[20px] text-black"
                >
                  Email Id
                </label>
                <Input
                  id="email"
                  placeholder="Enter your email"
                  className="w-full p-3 border border-black rounded-xl bg-[#FFF8EC] focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </Form.Item>

            <Form.Item
              name="message"
              rules={[{ required: true, message: "Please enter your message" }]}
              className="relative w-full"
            >
              <div className="relative">
                <label
                  htmlFor="message"
                  className="absolute -top-4 z-1 left-10 bg-[#FFF8EC] px-2 text-[20px] text-black"
                >
                  Your Message
                </label>
                <Input.TextArea
                  id="message"
                  placeholder="Enter your message"
                  rows={4}
                  className="w-full p-3 border bg-[#FFF8EC] border-black rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </Form.Item>

            <Form.Item>
              <div className="flex justify-start sm:justify-start">
                <button
                  type="submit"
                  className="bg-[#F9B138] h-12 rounded-2xl px-4 text-[20px] text-black w-[220px] whitespace-nowrap flex items-center justify-center"
                  disabled={loading} // Disable while loading
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </Form.Item>
          </Form>
        </div>
        <div className="w-full sm:w-1/2 space-y-3">
          <section id="contact-us" className="w-full  space-y-3">
            <div className="w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1755.7431801679925!2d77.31922!3d28.583507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce459b9eee365%3A0xc10324364915d53!2sBlock%20D%2C%209%2C%20Vyapar%20Marg%2C%20Block%20D%2C%20Noida%20Sector%203%2C%20Noida%2C%20Uttar%20Pradesh%20201301!5e0!3m2!1sen!2sin!4v1698334770840!5m2!1sen!2sin"
                width="100%"
                height="400"
                loading="lazy"
                style={{ border: "0", borderRadius: "10px" }}
                className="rounded-lg"
              ></iframe>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Counter;
